export default __webpack_public_path__ + "01f9b79c2f15f33d5089f29474ce3cb2.png";